import PropTypes from "prop-types";
import React, { Component } from "react";
import { select, scaleBand, scaleLinear, max, axisBottom, axisLeft } from "d3";
import Faux from "react-faux-dom";
import _ from "lodash";
import LegendComponent from "../legends/legendComponent";

class BarChart3DHorizontalComponent extends Component {
    constructor(props) {
        super(props);
        this.renderLegend = this.renderLegend.bind(this);
    }

    renderLegend() {
        const { hasLegend, data, size } = this.props;
        const dataEdit = _.map(data, (d, i) =>
            _.chain(d)
                .omit(["textValue"])
                .set("textValue", _.get(d, "value", ""))
                .value()
        );
        if (!_.isUndefined(hasLegend) && !_.isNull(hasLegend)) {
            if (hasLegend) {
                return <LegendComponent data={dataEdit} size={size} />;
            }
            return <span />;
        }
        return <span />;
    }

    render() {
        const { textVertical, textHorizontal, data, size, height, width } = this.props;

        const darkerColor = -45;
        let total = 0;
        _.forEach(data, d => {
            total += _.get(d, "value", 0);
        });
        if (total <= 0) {
            total = 100;
        }

        const dataEdit = _.chain(data)
            .map(d => _.set(d, "idx", _.get(d, "index")))
            .map((d, i) =>
                _.chain(d)
                    .omit(["index"])
                    .set("index", `#${i + 1}`)
                    .value()
            )
            .map(d => _.set(d, "percentage", getPercentage(d.value, total)))
            .value();

        const faux = Faux.createElement("div"),
            margin = { top: 20, right: 20, bottom: 50, left: 60 },
            barSpacing = getSpacingBar(_.size(dataEdit));

        const svg = select(faux)
            .append("svg")
            .attr("height", height)
            .attr("width", width)
            .style("page-break-inside", "avoid");

        const widthSvg = +width - margin.left - margin.right;
        const heightSvg = +height - margin.top - margin.bottom;

        const x = scaleLinear()
            .range([0, widthSvg])
            .domain([0, max(dataEdit, d => d.percentage)]);

        const y = scaleBand()
            .range([heightSvg, 0])
            .domain(_.map(dataEdit, d => d.index))
            .padding(barSpacing);

        const g = svg.append("g").attr("transform", `translate(${margin.left},${margin.top})`);

        const bars3D = g
            .selectAll(".bar3D")
            .data(dataEdit)
            .enter()
            .append("rect")
            .attr("class", "bar3D")
            .attr("y", d => y(d.index) - 12)
            .attr("x", d => 0)
            .attr("height", y.bandwidth() / 2)
            .attr("width", d => x(d.percentage))
            .attr("fill", d => LightenDarkenColor(d.color, darkerColor));

        const bars = g
            .selectAll(".bar")
            .data(dataEdit)
            .enter()
            .append("rect")
            .attr("class", "bar")
            .attr("y", d => y(d.index))
            .attr("x", d => 0)
            .attr("height", y.bandwidth())
            .attr("width", d => x(d.percentage))
            .attr("fill", d => d.color);

        /* const text = g
            .selectAll(".text")
            .data(dataEdit)
            .enter()
            .append("text")
            .attr("class", "text")
            .style("stroke-width", 2)
            .attr("font-size", 10)
            .attr("y", d => y(d.index) + 15)
            .attr("x", d => 5)
            .text(d => `${d.percentage}%`); */

        // Lines with the values
        const xAxis = g
            .append("g")
            .attr("class", "axis axis--x-h")
            .attr("transform", `translate(0,${heightSvg})`)
            .call(axisBottom(x).ticks(5));
        changeColorAxis("#AAA", xAxis);

        /* const yAxis = g
            .append("g")
            .attr("class", "axis axis--y-h")
            .call(axisLeft(y));
        changeColorAxis("#AAA", yAxis); */

        if (validText(textVertical)) {
            // text label for the y axis
            g
                .append("text")
                .attr("transform", "rotate(-90)")
                .attr("y", 0 - margin.left)
                .attr("x", 0 - heightSvg / 2)
                .attr("dy", "1em")
                .style("text-anchor", "middle")
                .text(textVertical);
        }

        if (validText(textHorizontal)) {
            // text label for the x axis
            g
                .append("text")
                .attr("transform", `translate( ${widthSvg / 2}, ${heightSvg + margin.top + 20})`)
                .style("text-anchor", "middle")
                .text(textHorizontal);
        }

        return (
            <div style={{ display: "inline-block", width: width + 2 }}>
                <div style={{ textAlign: "center", width, display: "inline-block" }}>{faux.toReact()}</div>
                {this.renderLegend()}
            </div>
        );
    }
}

function getPercentage(value, total) {
    const por = _.toNumber(value) * 100 / total;
    return por.toFixed(1);
}

function getSpacingBar(sizeData) {
    if (sizeData <= 3) {
        return 0.4;
    } else if (sizeData > 3 && sizeData <= 5) {
        return 0.3;
    } else if (sizeData > 5 && sizeData <= 7) {
        return 0.2;
    }
    return 0.1;
}

function changeColorAxis(color, axis) {
    axis.selectAll("line").style("stroke", color);
    axis.selectAll("path").style("stroke", color);
    axis
        .selectAll("text")
        .style("stroke", color)
        .style("stroke-width", ".4");
}

function validText(text) {
    return !(_.isUndefined(text) || _.isNull(text) || _.isEqual(text, ""));
}

function getValueSize(size, defaultSize) {
    switch (size) {
        case "small":
            return 250;
        case "middle":
            return 360;
        case "large":
            return 470;
        default:
            return defaultSize;
    }
}

function LightenDarkenColor(col, amt) {
    let usePound = false;
    if (col[0] == "#") {
        col = col.slice(1);
        usePound = true;
    }
    let num = parseInt(col, 16),
        r = (num >> 16) + amt;
    if (r > 255) r = 255;
    else if (r < 0) r = 0;
    let b = ((num >> 8) & 0x00ff) + amt;
    if (b > 255) b = 255;
    else if (b < 0) b = 0;
    let g = (num & 0x0000ff) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
}

BarChart3DHorizontalComponent.propTypes = {
    data: PropTypes.array.isRequired,
    textVertical: PropTypes.string,
    textHorizontal: PropTypes.string,
    hasLegend: PropTypes.bool,
    size: PropTypes.oneOf(["small", "middle", "large"]),
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired
};

export default BarChart3DHorizontalComponent;
